import { RouteProp, useFocusEffect, useRoute } from '@react-navigation/native';
import React, { Fragment, useCallback } from 'react';
import styled from 'styled-components/native';
import ActivityIndicatorScreen from '../../components/ActivityIndicatorScreen';
import AlertBox from '../../components/AlertBox';
import Colors from '../../constants/Colors';
import { useGetScreen } from '../../hooks/screen/useGetScreen';
import { DiscoverParamList } from '../../navigation/DiscoverNavigator';
import DynamicScreenComponentView from './DynamicScreenComponentView';

const StyledScrollView = styled.ScrollView`
  background-color: ${Colors.background};
  padding: 12px;
`;

const DynamicScreen: React.FC = () => {
  const route = useRoute<RouteProp<DiscoverParamList, 'DynamicScreen'>>();
  const screenId = route.params.screenId;
  const { screen, loadingScreen, loadingScreenError, getScreen } =
    useGetScreen(screenId);
  useFocusEffect(
    useCallback(() => {
      if (screenId) getScreen();
    }, [screenId, getScreen])
  );
  return (
    <Fragment>
      <StyledScrollView>
        <DynamicScreenComponentView components={screen?.components || []} />
        {loadingScreenError && (
          <AlertBox severity='error'>{loadingScreenError.message}</AlertBox>
        )}
      </StyledScrollView>
      {loadingScreen || (!screen && <ActivityIndicatorScreen modal />)}
    </Fragment>
  );
};

export default DynamicScreen;
